import React, { useMemo } from "react";
import { Card, Text } from "@chakra-ui/react";
import { t } from "i18next";
import { totalLineStringMeters } from "../../../../../map/utils/map-utils";
import { observer } from "mobx-react";
import { useStores } from "../../../../../shared/stores/RootStore";
import { formatDistanceByUnit } from "../../../../../shared/utils/format-utils";
import { DistanceUnit } from "@keita/lanepatrol-sdk";

const i18Prefix = "home:route.stats";

const OsaWayStatsBase: React.FC = () => {
  const { routeDesignStore, osaWayStore, projectStore } = useStores();
  const osaWay = osaWayStore.getSelected()!;
  const { stats } = osaWay;
  const distanceUnit = projectStore.distanceUnit;

  const plannedDistance = useMemo(() => {
    if (!routeDesignStore.newPlannedTrajectory && osaWay.plannedDistance) {
      return osaWay.plannedDistance;
    }
    const plannedTrajectory =
      routeDesignStore.newPlannedTrajectory || osaWay.plannedTrajectory;

    return plannedTrajectory ? totalLineStringMeters(plannedTrajectory) : 0;
    // eslint-disable-next-line
  }, [osaWay.plannedDistance, routeDesignStore.newPlannedTrajectory]);

  return (
    <Card.Root p={2} fontSize="xs">
      <Text>
        {t(`${i18Prefix}.plannedDistance`, {
          value: formatDistanceByUnit(plannedDistance, distanceUnit),
          unit: distanceUnit === DistanceUnit.Imperial ? "mi" : "km",
        })}
      </Text>
      <Text>
        {t(`${i18Prefix}.totalDistance`, {
          value: formatDistanceByUnit(stats!.totalDistance, distanceUnit),
          unit: distanceUnit === DistanceUnit.Imperial ? "mi" : "km",
        })}
      </Text>
      <Text>
        {t(`${i18Prefix}.nNodes`)}
        {`: ${stats!.nNodes}`}
      </Text>
      <Text>
        {t(`${i18Prefix}.nNodesCoded`)}
        {`: ${stats!.nNodesCoded}`}
      </Text>
    </Card.Root>
  );
};

export const OsaWayStats = observer(OsaWayStatsBase);
